import { render, staticRenderFns } from "./CouponForBundlePromotionCreateForm.vue?vue&type=template&id=688fb2ae&"
import script from "./CouponForBundlePromotionCreateForm.vue?vue&type=script&lang=js&"
export * from "./CouponForBundlePromotionCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('688fb2ae')) {
      api.createRecord('688fb2ae', component.options)
    } else {
      api.reload('688fb2ae', component.options)
    }
    module.hot.accept("./CouponForBundlePromotionCreateForm.vue?vue&type=template&id=688fb2ae&", function () {
      api.rerender('688fb2ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CouponForBundlePromotionCreateForm.vue"
export default component.exports